import React from 'react';
import { AlertCircle, Loader2, MapPin } from 'lucide-react';


export default function DeliveryGpsStatus({ status, error }) {
  const style = status === 'success'
    ? 'bg-green-50 text-green-700'
    : status === 'error'
      ? 'bg-amber-50 text-amber-700'
      : 'bg-stone-50 text-stone-600';
  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-lg ${style}`} data-testid="gps-status">
      {status === 'pending' && <Loader2 className="h-4 w-4 animate-spin" />}
      {status === 'success' && <MapPin className="h-4 w-4" />}
      {status === 'error' && <AlertCircle className="h-4 w-4" />}
      <span className="text-sm">
        {status === 'pending' && 'Getting location...'}
        {status === 'success' && 'Location captured'}
        {status === 'error' && (error || 'Location unavailable')}
        {status === 'cleared' && 'No location saved'}
      </span>
    </div>
  );
}
